import React, {
  forwardRef,
  useCallback,
  useContext,
  useImperativeHandle,
} from 'react';
import classNames from 'classnames';
import { Button, Modal } from 'ncoded-component-library';
import {
  ModalProps,
  ModalRef,
} from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { useTranslation } from 'react-i18next';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import mixpanelService from 'services/mixpanelService';
import useGetMixpanelProps from 'hooks/useGetMixpanelProps';
import { MaxSecurityInterestRegisteredEventProps } from 'models/MixpanelEvents';

import './MaximumSecurityComingSoonModal.styles.scss';

type MaximumSecurityComingSoonModalProps = {
  className?: string;
} & ModalProps;

const MaximumSecurityComingSoonModal: React.ForwardRefRenderFunction<
  ModalRef,
  MaximumSecurityComingSoonModalProps
> = (props, ref) => {
  const { className, ...rest } = props;

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  const {
    dataRoom: { _id: dataRoomId, name: dataRoomName },
  } = useContext(DataRoomContext);

  useImperativeHandle(ref, () => modal, [modal]);

  const classes = classNames('maximum-security-coming-soon-modal', className);

  const { t } = useTranslation();

  const getMixpanelProps = useGetMixpanelProps();

  const handleNotify = useCallback(() => {
    mixpanelService.maxSecurityInterestRegistered(
      getMixpanelProps({
        dataRoomId,
        dataRoomName,
      }) as MaxSecurityInterestRegisteredEventProps,
    );

    modal?.close();
  }, [dataRoomId, dataRoomName, modal, getMixpanelProps]);

  return (
    <Modal
      ref={modalRef}
      className={classes}
      title={t('maximumSecurityComingSoonTitle')}
      {...rest}
    >
      <p>{t('maximumSecurityComingSoonDescription')}</p>

      <div className="actions">
        <Button variant="link" onClick={modal?.close}>
          {t('notNow')}
        </Button>

        <Button onClick={handleNotify}>{t('notifyMe')}</Button>
      </div>
    </Modal>
  );
};

export default forwardRef(MaximumSecurityComingSoonModal);
